import React from 'react';
import Header from "../../components/Header";
import Question from "../../components/Question";
import Footer from "../../components/Footer";

const StageOneIneligible = ({ type, handleFooterLinkClick }) => {
  const forwardButtonText = (type === 'review' ? 'Review answers' : 'Start again');
  const forwardButtonScreen = (type === 'review' ? 'review' : 'reset');

  return (
    <div className='wrapper'>
      <Header
        title=''
        heading='Eligibility Checker Result'
      />
      <Question
        heading='Unfortunately, you are not eligible for our PARTNERS Programme.'
        description='You must meet all of the essential conditions to be able to take part in the Programme. Your answers indicate that you do not meet one or more of the essential conditions.'
      />
      <Footer
        buttonText={forwardButtonText}
        forwardButtonScreen={forwardButtonScreen}
        changeScreen={handleFooterLinkClick}
      />
    </div>
  )
}

export default StageOneIneligible;